import { render, staticRenderFns } from "./MoveToSetBannerModal.vue?vue&type=template&id=0ea887c6&"
import script from "./MoveToSetBannerModal.vue?vue&type=script&lang=js&"
export * from "./MoveToSetBannerModal.vue?vue&type=script&lang=js&"
import style0 from "./MoveToSetBannerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports